import * as yup from "yup";

export const generateValidationSchema = (fields = [], customFields = []) => {
  const schema = fields.reduce((acc, field) => {
    const validations = field.validation || [];

    let fieldValidation;
    const typeRule = validations.find((v) => v.formikType);
    const type = typeRule?.formikType?.toLowerCase();

    switch (type) {
      case "string":
        fieldValidation = yup.string();
        break;
      case "email":
        fieldValidation = yup.string().email("Please enter a valid email");
        break;
      case "date":
        fieldValidation = yup.date();
        break;
      case "number":
        fieldValidation = yup.number();
        break;
      case "object":
        fieldValidation = yup.object();
        break;
      case "array":
        fieldValidation = yup.array();
        break;
      case "url":
        fieldValidation = yup.string().url("Please enter a valid URL");
        break;
      case "boolean":
        fieldValidation = yup.boolean();
        break;
      case "positive":
        fieldValidation = yup.number().positive();
        break;
      case "negative":
        fieldValidation = yup.number().negative();
        break;
      case "integer":
        fieldValidation = yup.number().integer();
        break;
      default:
        fieldValidation = yup.string();
    }

    validations.forEach((rule) => {
      if (rule.require) {
        fieldValidation = fieldValidation.required(rule.message || "This field is required");
      }
      if (rule.min !== undefined) {
        fieldValidation = fieldValidation.min(
          rule.value,
          rule.message || (type === "date" ? "Date is too small" : "Minimum value not met")
        );
      }
      if (rule.max !== undefined) {
        fieldValidation = fieldValidation.max(
          rule.value,
          rule.message || (type === "date" ? "Date is too large" : "Maximum value exceeded")
        );
      }
      if (rule.match) {
        const regexPattern = rule?.value?.replace(/^\/|\/$/g, "");
        const regex = new RegExp(regexPattern);
        fieldValidation = fieldValidation.matches(regex, rule.message || "Invalid format");
      }
      if (rule.formikType && rule.message) {
        fieldValidation = fieldValidation.typeError(rule.message);
      }
    });

    acc[field.name] = fieldValidation;
    return acc;
  }, {});

  // ✅ Add custom fields like account/contact
  customFields.forEach(({ name, schema: customSchema }) => {
    schema[name] = customSchema;
  });

  return schema;
};

export const toCamelCase = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word, index) =>
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join('');
}